import { gql } from "@apollo/client";

export const Fleet = gql`
query fleetList4GivenClient(
    $id: uuid
) {
    aatmsv4_fleets(order_by: {aircraft: asc}, where: {active: {_eq: true},
   _and: {clientsid: {_eq: $id}}}) {
    aircraft
    fleetsid
    } 
}
`
export const getClientId = gql`
query login(
    $id: String
) {
  aatmsv4_users(where: {userid: {_eq: $id}}) {
    client {
      clientname
      clientsid
    }
  }
}
`
export const Phase = gql `
query PhaseList {
    aatmsv4_phase {
      phaseid
    }
  }
`

export const Simulator_Query = gql`
query M_tc_sim(
    $id: uuid
    $fleetId: uuid
    $phases: aatmsv4_phase_enum
) {
    aatmsv4_stclist(order_by: {phase: asc, stcname: asc},
   where: {clientsid: {_eq: $id},
   fleetsid: {_eq: $fleetId}, phase:{_eq: $phases}}) {
    phase
    stcname
    active
    stcid
    stcshortname
    }}
`
export const Aircraft_Query = gql`
query M_tc_air(
    $id: uuid
    $fleetId: uuid
    $phases: aatmsv4_phase_enum
) {
    aatmsv4_atclist(order_by: {phase: asc, atcname: asc},
   where: {clientsid: {_eq: $id},
   fleetsid: {_eq: $fleetId}, phase:{_eq: $phases}}) {
    phase
    atcname
    active
    atcid
    atcshortname
    }}
`
export const Edit_simulator = gql`
mutation M_Tc_Edit_Sim(
    $id: uuid
    $phse: aatmsv4_phase_enum
    $shortname: String
    $name: String
    $active: Boolean
) {
    update_aatmsv4_stclist(where: {stcid: {_eq: $id}}, _set: {phase: $phse,
    stcshortname: $shortname, stcname: $name, active: $active}) {
    returning {
    phase
    stcshortname
    stcname
    active
    } } }
`
export const Edit_aircraft = gql`
mutation M_Tc_Edit_Sim(
    $id: uuid
    $phse: aatmsv4_phase_enum
    $shortname: String
    $name: String
    $active: Boolean
) {
    update_aatmsv4_atclist(where: {atcid: {_eq: $id}}, _set: {phase: $phse,
   atcshortname: $shortname, atcname: $name, active: $active}) {
    returning {
    phase
    atcshortname
    atcname
    active
    } } }
`

export const Insert_TC_Simulator = gql `
mutation M_tc_add_sim(
    $clientId: uuid
    $clientName: String
    $fleetId: uuid
    $phase: aatmsv4_phase_enum
    $shortName: String
    $stcName: String
    $ata: Int
) {
    insert_aatmsv4_stclist(objects: {clientsid: $clientId, clientname: $clientName,fleetsid: $fleetId, phase: $phase , stcshortname: $shortName, stcname: $stcName, active: true, _aircraft: true, _crew: true, _ground: true, _manager: true, _optimiser: true, _simulator: true, ata: $ata}) {
    returning {
    clientname
    fleet {
    aircraft
    }
    phase
    ata
    stcid
    stcshortname
    stcname
    } } }
`
export const Insert_TC_Aircraft = gql`
mutation M_tc_add_air(
    $clientId: uuid
    $clientName: String
    $fleetId: uuid
    $phase: aatmsv4_phase_enum
    $shortName: String
    $stcName: String
    $ata: Int
) {
insert_aatmsv4_atclist(objects: {clientsid: $clientId, clientname: $clientName,fleetsid: $fleetId, phase: $phase, atcshortname: $shortName, atcname: $stcName, active: true, _aircraft: true,_crew: true, _ground: true, _manager: true, _optimiser: true, _simulator: true, ata: $ata}) {
    returning {
    clientname
    fleet {
    aircraft
    }
    phase
    ata
    atcid
    atcshortname
    atcname
    } } }
`